import React from "react";

export default function AboutUs() {
  return (
    <div className="_w-100 text-bg-dark text-white pt-5 pb-5 mt-3 information">
      <div className="m-auto pt-3">
        <h1>About Us</h1>
        <span>18+</span>
        <p>
          Our mission is to assist users in making informed decisions among a
          wide array of websites, platforms, services, and apps. Our dedicated
          teams of researchers and advisors have thoroughly explored every
          aspect of the industry to bring you the most accurate information.
        </p>
        <p>
          Our charts, lists, reviews, guides, and tips are available to you at
          no cost, helping you choose what’s best for your needs.
        </p>
        <h2>Contact Us</h2>
        <p>
          Did you find our site helpful? Do you have suggestions for
          improvement? We would love to hear from you.
        </p>
        <p>
          For general inquiries, comments, or suggestions, feel free to email us
          at xxx@xxx.com.
        </p>
      </div>
    </div>
  );
}
